module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('card-modal', {
    attrs: {
      "visible": true,
      "title": _vm.title,
      "showPreview": false,
      "okText": 'Guardar',
      "disableOk": true
    }
  }, [_c('div', {
    staticClass: "content",
    attrs: {
      "id": "modal-edit-content"
    }
  }, [(_vm.userLoggedAdmin) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "swicth-container"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Administrador")]), _vm._v(" "), _c('vb-switch', {
    attrs: {
      "type": "primary",
      "checked": _vm.userData && !!parseInt(_vm.userData.admin)
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nome de utilizador")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Nome"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Email",
      "disabled": _vm.disableEmail
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nova password")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.newPassword),
      expression: "user.newPassword"
    }],
    staticClass: "input password-input",
    class: {
      'is-danger': _vm.passwordMissmatch
    },
    attrs: {
      "type": "password",
      "placeholder": "Nova password"
    },
    domProps: {
      "value": (_vm.user.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.newPassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Repetir password")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.newPasswordRepeat),
      expression: "user.newPasswordRepeat"
    }],
    staticClass: "input password-input",
    class: {
      'is-danger': _vm.passwordMissmatch
    },
    attrs: {
      "type": "password",
      "placeholder": "Repetir password"
    },
    domProps: {
      "value": (_vm.user.newPasswordRepeat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.newPasswordRepeat = $event.target.value
      }
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c942cbe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/UserEditModal.vue
// module id = 332
// module chunks = 1